module.exports = __webpack_public_path__ + "static/media/logo.7e754a9c.png";